/* HWD Gravur-Kern: Datenmodell, Regeln und die eine Zeichenroutine

   Gemeinsame Grundlage aller Konfiguratoren - Fotogravur auf Holz, Zippo,
   Grillzange, Bieroeffner, Anhaenger und was noch kommt.

   Architektur in einem Satz: Es gibt EINE Zeichenroutine, die in Millimetern
   rechnet. Sie bedient den Bildschirm und den Beleg, der an die Bestellung
   geht. Beide koennen deshalb nicht auseinanderlaufen.

   Koordinaten: alle Elementwerte in Millimetern, gemessen von der Mitte der
   Nutzflaeche. Damit steht in der Bestellung dieselbe Sprache wie an der
   Maschine - keine Prozentwerte, die jemand umrechnen muss.

   Zwei Welten, eine Routine:
     heller Grund - dunkle Gravur (Holz, Brand).
     dunkler Grund - helle Gravur (lackiertes Metall; der Laser traegt den
                     Lack ab und legt das Metall frei).

   Form (opt.form): rechteck (mit opt.radius), kreis, oval, herz, blume. Der
   Umriss IST das Werkstueck - alles Gravierte wird darauf beschnitten. Der
   Eckenradius steht je Produkt auf 0, damit Werkstuecke mit scharfen Ecken
   auch scharfe Ecken behalten.

   Kreis und Oval sind dieselbe Rechnung: eine Ellipse, die das Rechteck aus
   Breite und Hoehe ausfuellt. Bei gleichen Massen kommt ein Kreis heraus,
   bei ungleichen ein Oval. Zwei Namen gibt es trotzdem, damit im
   Theme-Editor nicht "Kreis" ueber einer Astscheibe steht.

   Flache Unterseite (opt.flach): die Tischnummer ist unten gerade
   abgeschnitten, weil sie dort auf eine Unterkonstruktion geleimt wird.
   Angegeben wird die Breite der Schnittkante. Daraus rechnet der Kern die
   gedachte Vollellipse zurueck, sodass das Werkstueck am Ende genau die
   eingestellte Hoehe hat - die Zahl an der Bemassung stimmt also mit dem
   gekappten Stueck ueberein und nicht mit einer Ellipse, die es so gar
   nicht gibt.

   Das Herz ist die echte Laserkontur aus Herz.svg, auf das Einheitsquadrat
   normiert: dieselben acht Bezierstuecke, nur ohne Masseinheit. Was der
   Kunde in der Vorschau sieht, ist damit exakt das, was die Maschine
   ausschneidet - kein nachempfundener Umriss.

   Die Blume ist als Polarkurve gezeichnet, nicht als Haufen ueberlappender
   Kreise: gefuellt saehe beides gleich aus, umrandet zeigten die Kreise
   jede Konstruktionslinie.

   Loch (opt.loch = { d, y }): etwa die Bohrung am Schluesselanhaenger. Sie
   wird aus Material UND Nutzflaeche ausgespart - dort kann nichts liegen.

   Raender: z.randX und z.randY halten seitlich und oben/unten getrennt frei.
   Bei runden Formen wird die Nutzflaeche entsprechend verkleinert, nicht
   rechteckig beschnitten.

   Sperrzone (z.sperreLinks / z.sperreRechts): ein Streifen an einer Seite,
   auf dem nichts liegen darf - beim Nussholz-Anhaenger etwa die Lasche, mit
   der das Lederband am Holz sitzt. Anders als der Rand ist sie einseitig,
   und auf der Rueckseite liegt sie spiegelbildlich gegenueber. Sie
   verschiebt die Mitte der Nutzflaeche, damit neue Elemente gleich richtig
   landen, und wird in der Vorschau leicht eingefaerbt.

   Bilder kommen fertig eingefaerbt herein (siehe hwd-foto-bild.js): eine
   Auflage in Gravurfarbe, deren Deckkraft die Gravurtiefe meint.

   Schleier hinter der Schrift: Rund um jede Textzeile bleibt der Grund
   unangetastet - genau das, was die Maschine dort tut, naemlich nichts.

   Saum: Die Leinwand ist groesser als das Werkstueck. In diesem Rand liegen
   die Anfasser und die Bemassung. Der Beleg wird ohne Saum gerendert.
*/
window.HWDKern = (function () {
  'use strict';

  var K = {
    MIN_MM: 50, MAX_LANG: 300, MAX_KURZ: 200,
    MAX_BILDER: 8, MAX_ELEMENTE: 14,
    MAX_DATEI: 20 * 1024 * 1024,
    DPI_GUT: 150, DPI_MITTEL: 100,
    SCHRIFT_MIN: 2.5,
    BELEG_PX_PRO_MM: 8,
    UNDO_TIEFE: 40,
    GRIFF_PX: 11,
    DREH_PX: 22,
    SAUM_PX: 30,
    SCHLEIER: 0.34,
    HOLZ: { pappel: '#E8D9C0', birke: '#F0E4D0', mdfweiss: '#F7F5F0' },
    FONTS: { serif: 'Georgia, serif', sans: 'Arial, Helvetica, sans-serif', script: 'cursive' },
    FONTNAMEN: { serif: 'Klassisch', sans: 'Schlicht', script: 'Handschrift' },
    AUSRICHTUNG: { links: 'linksbündig', mitte: 'zentriert', rechts: 'rechtsbündig' },
    FORMNAMEN: { rechteck: 'Rechteck', kreis: 'Kreis', oval: 'Oval', herz: 'Herz', blume: 'Blume' },
    BRENN: 'rgba(62,40,22,0.92)',
    AKZENT: '#B4622D'
  };

  var VORLAGEN = [
    { id: 'standard', name: 'Standard', mm: 8, font: 'serif', fett: false, kursiv: false, align: 'mitte', za: 1.25 },
    { id: 'titel', name: 'Titel', mm: 14, font: 'serif', fett: true, kursiv: false, align: 'mitte', za: 1.1 },
    { id: 'ueberschrift', name: 'Überschrift', mm: 10, font: 'sans', fett: true, kursiv: false, align: 'mitte', za: 1.15 },
    { id: 'fliesstext', name: 'Fließtext', mm: 6, font: 'sans', fett: false, kursiv: false, align: 'links', za: 1.35 },
    { id: 'zitat', name: 'Zitat', mm: 8, font: 'script', fett: false, kursiv: true, align: 'mitte', za: 1.3 },
    { id: 'klein', name: 'Kleingedrucktes', mm: 4.5, font: 'sans', fett: false, kursiv: false, align: 'mitte', za: 1.2 }
  ];

  var messCtx = document.createElement('canvas').getContext('2d');

  function kommazahl(n, stellen) {
    var f = Math.pow(10, stellen || 0);
    return String(Math.round(n * f) / f).replace('.', ',');
  }

  function schriftString(e, groesse) {
    return (e.kursiv ? 'italic ' : '') + (e.fett ? 'bold ' : '') + groesse + 'px ' + K.FONTS[e.font];
  }

  function abstaendeNullen(g) {
    try {
      if ('letterSpacing' in g) g.letterSpacing = '0px';
      if ('wordSpacing' in g) g.wordSpacing = '0px';
    } catch (e) { /* aeltere Browser kennen das nicht */ }
  }

  function raender(z) {
    return {
      x: z.randX != null ? z.randX : (z.rand || 0),
      y: z.randY != null ? z.randY : (z.rand || 0)
    };
  }

  function sperre(z) {
    return { links: z.sperreLinks || 0, rechts: z.sperreRechts || 0 };
  }

  /* ---------- Formen ---------- */
  function rundRechteck(g, x, y, b, h, r) {
    r = Math.max(0, Math.min(r, b / 2, h / 2));
    g.moveTo(x + r, y);
    g.lineTo(x + b - r, y);
    g.quadraticCurveTo(x + b, y, x + b, y + r);
    g.lineTo(x + b, y + h - r);
    g.quadraticCurveTo(x + b, y + h, x + b - r, y + h);
    g.lineTo(x + r, y + h);
    g.quadraticCurveTo(x, y + h, x, y + h - r);
    g.lineTo(x, y + r);
    g.quadraticCurveTo(x, y, x + r, y);
    g.closePath();
  }

  /* Ellipse, unten auf der Breite "flach" gerade abgeschnitten.

     Gesucht ist die Vollellipse, von der nach dem Schnitt genau h uebrig
     bleibt. Mit a = b/2 und k = flach / b gilt am Schnitt
       flach/2 = a * sqrt(1 - ((h - be) / be)^2)
     und daraus
       be = h / (1 + sqrt(1 - k^2)).
     Der Parameterwinkel am Schnitt ist t = asin(sqrt(1 - k^2)); von dort
     laeuft der Bogen ueber den Scheitel zur anderen Schnittkante, die
     Gerade unten schliesst closePath(). */
  function ovalPfad(g, b, h, flach) {
    var a = b / 2;
    if (!(flach > 0) || flach >= b) {
      g.moveTo(b, h / 2);
      g.ellipse(a, h / 2, a, h / 2, 0, 0, Math.PI * 2);
      return;
    }
    var k = flach / b;
    var s = Math.sqrt(1 - k * k);
    var be = h / (1 + s);
    var t = Math.asin(s);
    g.ellipse(a, be, a, be, 0, t, -Math.PI - t, true);
    g.closePath();
  }

  /* Die Laserkontur des Herzens, auf 0..1 normiert.
     Quelle: Herz.svg, 55 x 54,98 mm, ein Zug aus zwei Geraden (die Spitze)
     und sechs Bezierstuecken. Der Ursprung liegt links oben, die Spitze
     unten in der Mitte - so wie die Leinwand rechnet. */
  function herzPfad(g, b, h) {
    function p(u, v) { return [u * b, v * h]; }
    function bez(c1u, c1v, c2u, c2v, eu, ev) {
      g.bezierCurveTo(c1u * b, c1v * h, c2u * b, c2v * h, eu * b, ev * h);
    }
    var s = p(0.5, 1);
    g.moveTo(s[0], s[1]);
    var l = p(0.594917, 0.905048);
    g.lineTo(l[0], l[1]);
    bez(0.809570, 0.686748, 1.000000, 0.468441, 1.000000, 0.250133);
    bez(1.000000, 0.112059, 0.887983, 0.000000, 0.750001, 0.000000);
    bez(0.624999, 0.000000, 0.562499, 0.062534, 0.500000, 0.187597);
    bez(0.437501, 0.062533, 0.375000, 0.000000, 0.249999, 0.000000);
    bez(0.112000, 0.000000, 0.000000, 0.112058, 0.000000, 0.250132);
    bez(0.000000, 0.468399, 0.190357, 0.686664, 0.404966, 0.904930);
    g.closePath();
  }

  function formPfad(g, form, mm, radius, flach) {
    var b = mm.b, h = mm.h, i;
    if (form === 'kreis' || form === 'oval') {
      ovalPfad(g, b, h, flach);
      return;
    }
    if (form === 'herz') {
      herzPfad(g, b, h);
      return;
    }
    if (form === 'blume') {
      /* Sechs Blueten als Polarkurve: der Radius schwingt zwischen 40 % und
         100 % des Umkreises. Ein Zug, eine Kontur, keine Hilfslinien. */
      var R = Math.min(b, h) / 2, cx = b / 2, cy = h / 2, n = 240;
      for (i = 0; i <= n; i++) {
        var phi = i * 2 * Math.PI / n;
        var rr = R * (0.70 + 0.30 * Math.cos(6 * phi));
        var x = cx + Math.cos(phi) * rr;
        var y = cy + Math.sin(phi) * rr;
        if (i === 0) g.moveTo(x, y); else g.lineTo(x, y);
      }
      g.closePath();
      return;
    }
    rundRechteck(g, 0, 0, b, h, radius || 0);
  }

  function werkstueckPfad(g, mm, opt, schrumpfX, schrumpfY) {
    g.beginPath();
    if (schrumpfX !== 1 || schrumpfY !== 1) {
      g.save();
      g.translate(mm.b / 2, mm.h / 2);
      g.scale(schrumpfX, schrumpfY);
      g.translate(-mm.b / 2, -mm.h / 2);
      formPfad(g, opt.form, mm, opt.radius, opt.flach);
      g.restore();
    } else {
      formPfad(g, opt.form, mm, opt.radius, opt.flach);
    }
    var l = opt.loch;
    if (l && l.d > 0) {
      var ly = l.y != null ? l.y : l.d;
      g.moveTo(mm.b / 2 + l.d / 2, ly);
      g.arc(mm.b / 2, ly, l.d / 2, 0, Math.PI * 2, true);
    }
  }

  function neuerZustand() {
    return {
      idx: 0, frei: false, quer: false, freiB: 150, freiH: 100, rand: 0,
      elemente: [], aktivId: null, naechsteId: 1,
      ansicht: 'gravur', bestaetigt: false, schritt: 1
    };
  }

  function masse(z, FORMATE) {
    if (z.frei) return { b: z.freiB, h: z.freiH };
    var f = FORMATE[z.idx];
    return z.quer ? { b: f.lang, h: f.kurz } : { b: f.kurz, h: f.lang };
  }

  function nutz(z, FORMATE) {
    var m = masse(z, FORMATE);
    var r = raender(z);
    return { b: m.b - 2 * r.x, h: m.h - 2 * r.y };
  }

  function passt(m) {
    var lang = Math.max(m.b, m.h), kurz = Math.min(m.b, m.h);
    return lang <= K.MAX_LANG && kurz <= K.MAX_KURZ && kurz >= K.MIN_MM && lang >= K.MIN_MM;
  }

  function variante(z, FORMATE, STUFEN) {
    if (!z.frei) return FORMATE[z.idx];
    var m = masse(z, FORMATE);
    var flaeche = m.b * m.h / 100;
    for (var i = 0; i < STUFEN.length; i++) if (flaeche <= STUFEN[i].max) return STUFEN[i];
    return STUFEN[STUFEN.length - 1] || null;
  }

  function bildMasse(e) {
    var ai = e.bildB / e.bildH;
    return { b: e.breite, h: e.breite / ai };
  }

  function dpiVon(e) {
    if (e.typ !== 'bild' || !e.breite) return 0;
    return Math.round(e.bildB / (e.breite / 25.4));
  }

  function qualitaet(e) {
    var d = dpiVon(e);
    if (!d) return { stufe: 'gut', dpi: 0 };
    if (d >= K.DPI_GUT) return { stufe: 'gut', dpi: d };
    if (d >= K.DPI_MITTEL) return { stufe: 'mittel', dpi: d };
    return { stufe: 'schlecht', dpi: d };
  }

  /* ---------- Text ---------- */
  function zeichneZeile(g, text, x, y, align, laufweite, strich) {
    var malen;
    if (strich > 0) {
      g.lineWidth = strich;
      malen = function (s, px, py) { g.strokeText(s, px, py); };
    } else {
      malen = function (s, px, py) { g.fillText(s, px, py); };
    }
    if (!laufweite) {
      g.textAlign = align === 'links' ? 'left' : (align === 'rechts' ? 'right' : 'center');
      malen(text, x, y);
      return;
    }
    var zeichen = String(text).split('');
    var gesamt = 0, i;
    for (i = 0; i < zeichen.length; i++) gesamt += g.measureText(zeichen[i]).width + laufweite;
    gesamt -= laufweite;
    var start = align === 'links' ? x : (align === 'rechts' ? x - gesamt : x - gesamt / 2);
    g.textAlign = 'left';
    for (i = 0; i < zeichen.length; i++) {
      malen(zeichen[i], start, y);
      start += g.measureText(zeichen[i]).width + laufweite;
    }
  }

  function zeilenBreite(g, text, laufweite) {
    if (!laufweite) return g.measureText(text).width;
    var zeichen = String(text).split('');
    var w = 0;
    for (var i = 0; i < zeichen.length; i++) w += g.measureText(zeichen[i]).width + laufweite;
    return w - laufweite;
  }

  function zeilenBerechnen(e) {
    var bezug = 100;
    abstaendeNullen(messCtx);
    messCtx.font = schriftString(e, bezug);
    var maxB = e.breite / e.mm * bezug;
    var lauf = (e.laufweite || 0) / e.mm * bezug;
    var raus = [];
    String(e.text).split('\n').forEach(function (absatz) {
      var worte = absatz.split(' ');
      var zeile = '';
      worte.forEach(function (w) {
        var test = zeile ? zeile + ' ' + w : w;
        if (zeile && zeilenBreite(messCtx, test, lauf) > maxB) { raus.push(zeile); zeile = w; }
        else zeile = test;
      });
      raus.push(zeile);
    });
    e.zeilen = raus;
    return raus;
  }

  function textHoehe(e) {
    return (e.zeilen ? e.zeilen.length : 1) * e.mm * e.za;
  }

  function rahmen(e) {
    if (e.typ === 'bild') return bildMasse(e);
    return { b: e.breite, h: textHoehe(e) };
  }

  function mitte(z, mm) {
    var r = raender(z);
    var s = sperre(z);
    return {
      x: r.x + s.links + (mm.b - 2 * r.x - s.links - s.rechts) / 2,
      y: r.y + (mm.h - 2 * r.y) / 2
    };
  }

  function griffe(e, z, mm, pxProMm, saum) {
    saum = saum || 0;
    var c = mitte(z, mm);
    var r = rahmen(e);
    var w = (e.drehung || 0) * Math.PI / 180;
    var cos = Math.cos(w), sin = Math.sin(w);
    var cx = c.x + e.x, cy = c.y + e.y;
    var innen = K.GRIFF_PX * 0.7 / pxProMm;

    function welt(lx, ly) {
      return { x: cx + lx * cos - ly * sin, y: cy + lx * sin + ly * cos };
    }
    function klemm(p) {
      return {
        x: Math.max(-saum + innen, Math.min(mm.b + saum - innen, p.x)),
        y: Math.max(-saum + innen, Math.min(mm.h + saum - innen, p.y))
      };
    }
    return {
      mitte: { x: cx, y: cy },
      ecken: [
        klemm(welt(-r.b / 2, -r.h / 2)), klemm(welt(r.b / 2, -r.h / 2)),
        klemm(welt(r.b / 2, r.h / 2)), klemm(welt(-r.b / 2, r.h / 2))
      ],
      dreh: klemm(welt(0, -r.h / 2 - K.DREH_PX / pxProMm)),
      rahmen: r, winkel: w
    };
  }

  /* ---------- Die eine Zeichenroutine ---------- */
  function zeichneSzene(g, z, mm, pxProMm, opt) {
    opt = opt || {};
    var ansicht = opt.ansicht || 'gravur';
    var saum = opt.saum || 0;
    var grund = opt.grund || K.HOLZ[opt.material] || K.HOLZ.pappel;
    var brenn = opt.brenn || K.BRENN;
    var r = raender(z);
    var sp = sperre(z);
    var schrumpfX = mm.b > 0 ? (mm.b - 2 * r.x) / mm.b : 1;
    var schrumpfY = mm.h > 0 ? (mm.h - 2 * r.y) / mm.h : 1;
    var c = mitte(z, mm);

    g.save();
    abstaendeNullen(g);
    g.scale(pxProMm, pxProMm);
    g.translate(saum, saum);

    werkstueckPfad(g, mm, opt, 1, 1);
    g.fillStyle = grund;
    g.fill();

    g.save();
    werkstueckPfad(g, mm, opt, schrumpfX, schrumpfY);
    g.clip();
    if (sp.links > 0 || sp.rechts > 0) {
      g.beginPath();
      g.rect(sp.links, 0, mm.b - sp.links - sp.rechts, mm.h);
      g.clip();
    }

    z.elemente.forEach(function (e) {
      g.save();
      g.translate(c.x + e.x, c.y + e.y);
      if (e.drehung) g.rotate(e.drehung * Math.PI / 180);

      if (e.typ === 'bild') {
        var gr = bildMasse(e);
        var quelle = opt.bilder ? opt.bilder(e, gr, pxProMm, ansicht) : null;
        if (quelle) {
          if (e.spiegel) g.scale(-1, 1);
          g.imageSmoothingEnabled = true;
          g.drawImage(quelle, -gr.b / 2, -gr.h / 2, gr.b, gr.h);
        } else {
          g.strokeStyle = 'rgba(176,58,46,.8)';
          g.lineWidth = 0.5;
          g.setLineDash([2, 2]);
          g.strokeRect(-gr.b / 2, -gr.h / 2, gr.b, gr.h);
          g.setLineDash([]);
          g.fillStyle = 'rgba(176,58,46,.85)';
          g.font = schriftString({ font: 'sans' }, Math.min(gr.h / 6, 6));
          g.textAlign = 'center';
          g.textBaseline = 'middle';
          g.fillText('Datei erneut wählen', 0, 0);
        }
      } else {
        var zeilen = e.zeilen && e.zeilen.length ? e.zeilen : zeilenBerechnen(e);
        g.font = schriftString(e, e.mm);
        g.textBaseline = 'middle';
        var lh = e.mm * e.za;
        var start = -(zeilen.length - 1) * lh / 2;
        var ax = e.align === 'links' ? -e.breite / 2 : (e.align === 'rechts' ? e.breite / 2 : 0);
        var lauf = e.laufweite || 0;
        var i, runde;

        var schleier = (e.schleier == null ? K.SCHLEIER : e.schleier) * e.mm;
        if (schleier > 0) {
          g.save();
          g.fillStyle = grund;
          g.strokeStyle = grund;
          g.shadowColor = grund;
          g.shadowBlur = schleier * pxProMm;
          g.lineJoin = 'round';
          g.lineCap = 'round';
          for (runde = 0; runde < 4; runde++) {
            var strich = runde < 2 ? schleier * 0.5 : 0;
            for (i = 0; i < zeilen.length; i++) {
              zeichneZeile(g, zeilen[i], ax, start + i * lh, e.align, lauf, strich);
            }
          }
          g.restore();
        }

        g.fillStyle = brenn;
        for (i = 0; i < zeilen.length; i++) {
          zeichneZeile(g, zeilen[i], ax, start + i * lh, e.align, lauf, 0);
        }
      }
      g.restore();
    });

    g.restore();

    /* Die Sperrzone wird nach den Elementen getoent: sie liegt ueber dem
       Holz, nicht darunter, und macht so auch dann klar, dass dort nichts
       hingehoert, wenn jemand etwas hineinzieht. */
    if ((sp.links > 0 || sp.rechts > 0) && !opt.beleg) {
      g.save();
      werkstueckPfad(g, mm, opt, 1, 1);
      g.clip();
      g.fillStyle = opt.sperrfarbe || 'rgba(110,80,50,0.18)';
      if (sp.links > 0) g.fillRect(0, 0, sp.links, mm.h);
      if (sp.rechts > 0) g.fillRect(mm.b - sp.rechts, 0, sp.rechts, mm.h);
      g.strokeStyle = opt.randfarbe || 'rgba(180,98,45,0.5)';
      g.lineWidth = 0.25;
      g.setLineDash([2, 2]);
      g.beginPath();
      if (sp.links > 0) { g.moveTo(sp.links, 0); g.lineTo(sp.links, mm.h); }
      if (sp.rechts > 0) { g.moveTo(mm.b - sp.rechts, 0); g.lineTo(mm.b - sp.rechts, mm.h); }
      g.stroke();
      g.setLineDash([]);
      g.restore();
    }

    if (opt.linien && opt.linien.length) {
      g.save();
      g.strokeStyle = opt.linienfarbe || 'rgba(0,0,0,0.3)';
      g.lineWidth = 0.3;
      g.setLineDash([2, 1.6]);
      opt.linien.forEach(function (l) {
        g.beginPath();
        if (l.y != null) { g.moveTo(0, l.y); g.lineTo(mm.b, l.y); }
        else { g.moveTo(l.x, 0); g.lineTo(l.x, mm.h); }
        g.stroke();
      });
      g.setLineDash([]);
      g.restore();
    }

    werkstueckPfad(g, mm, opt, 1, 1);
    g.strokeStyle = opt.kontur || 'rgba(90,60,35,0.45)';
    g.lineWidth = 0.3;
    g.stroke();

    if ((r.x > 0 || r.y > 0) && !opt.beleg) {
      werkstueckPfad(g, mm, opt, schrumpfX, schrumpfY);
      g.strokeStyle = opt.randfarbe || 'rgba(180,98,45,0.5)';
      g.lineWidth = 0.25;
      g.setLineDash([2, 2]);
      g.stroke();
      g.setLineDash([]);
    }

    if (saum > 0 && !opt.beleg) zeichneMasse(g, mm, pxProMm, saum, opt.massfarbe);

    if (opt.auswahl != null && !opt.beleg) {
      var a = null;
      for (var j = 0; j < z.elemente.length; j++) if (z.elemente[j].id === opt.auswahl) a = z.elemente[j];
      if (a) zeichneGriffe(g, a, z, mm, pxProMm, saum);
    }

    g.restore();
  }

  function zeichneMasse(g, mm, pxProMm, saum, farbe) {
    var fs = 11 / pxProMm;
    var abstand = saum * 0.42;
    g.save();
    g.fillStyle = farbe || 'rgba(90,60,35,0.7)';
    g.strokeStyle = farbe || 'rgba(90,60,35,0.35)';
    g.lineWidth = 0.8 / pxProMm;
    g.font = fs + 'px ' + K.FONTS.sans;

    g.beginPath();
    g.moveTo(0, mm.h + abstand);
    g.lineTo(mm.b, mm.h + abstand);
    g.stroke();
    g.textAlign = 'center';
    g.textBaseline = 'top';
    g.fillText(kommazahl(mm.b, 1) + ' mm', mm.b / 2, mm.h + abstand + fs * 0.25);

    g.beginPath();
    g.moveTo(mm.b + abstand, 0);
    g.lineTo(mm.b + abstand, mm.h);
    g.stroke();
    g.save();
    g.translate(mm.b + abstand + fs * 0.25, mm.h / 2);
    g.rotate(Math.PI / 2);
    g.textAlign = 'center';
    g.textBaseline = 'top';
    g.fillText(kommazahl(mm.h, 1) + ' mm', 0, 0);
    g.restore();

    g.restore();
  }

  function zeichneGriffe(g, e, z, mm, pxProMm, saum) {
    var gr = griffe(e, z, mm, pxProMm, saum);
    var hs = K.GRIFF_PX / pxProMm;
    var strich = 1.4 / pxProMm;

    g.save();
    g.translate(gr.mitte.x, gr.mitte.y);
    g.rotate(gr.winkel);
    g.strokeStyle = K.AKZENT;
    g.lineWidth = strich;
    g.setLineDash([3 / pxProMm, 2.5 / pxProMm]);
    g.strokeRect(-gr.rahmen.b / 2, -gr.rahmen.h / 2, gr.rahmen.b, gr.rahmen.h);
    g.setLineDash([]);
    g.restore();

    g.strokeStyle = K.AKZENT;
    g.lineWidth = strich;
    g.beginPath();
    g.moveTo(gr.mitte.x, gr.mitte.y);
    g.lineTo(gr.dreh.x, gr.dreh.y);
    g.stroke();

    g.beginPath();
    g.arc(gr.dreh.x, gr.dreh.y, hs * 0.55, 0, Math.PI * 2);
    g.fillStyle = '#FFFDF8';
    g.fill();
    g.stroke();

    g.fillStyle = '#FFFDF8';
    gr.ecken.forEach(function (p) {
      g.beginPath();
      g.rect(p.x - hs / 2, p.y - hs / 2, hs, hs);
      g.fill();
      g.stroke();
    });
  }

  function lokal(e, cx, cy, px, py) {
    var dx = px - cx, dy = py - cy;
    if (!e.drehung) return { x: dx, y: dy };
    var w = -e.drehung * Math.PI / 180;
    return { x: dx * Math.cos(w) - dy * Math.sin(w), y: dx * Math.sin(w) + dy * Math.cos(w) };
  }

  function greifen(z, mm, px, py, pxProMm, aktivId, saum) {
    var c = mitte(z, mm);
    var fang = (K.GRIFF_PX + 7) / pxProMm;
    var i, e;

    for (i = 0; i < z.elemente.length; i++) {
      if (z.elemente[i].id !== aktivId) continue;
      e = z.elemente[i];
      var gr = griffe(e, z, mm, pxProMm, saum);
      if (Math.abs(px - gr.dreh.x) < fang && Math.abs(py - gr.dreh.y) < fang) {
        return { element: e, art: 'drehen' };
      }
      for (var k = 0; k < 4; k++) {
        if (Math.abs(px - gr.ecken[k].x) < fang && Math.abs(py - gr.ecken[k].y) < fang) {
          return { element: e, art: 'skalieren' };
        }
      }
      break;
    }

    for (i = z.elemente.length - 1; i >= 0; i--) {
      e = z.elemente[i];
      var q = lokal(e, c.x + e.x, c.y + e.y, px, py);
      var rr = rahmen(e);
      if (Math.abs(q.x) <= rr.b / 2 && Math.abs(q.y) <= rr.h / 2) return { element: e, art: 'bewegen' };
    }
    return null;
  }

  /* ---------- Speichern ---------- */
  function ohneZeilen(e) {
    var k = {};
    for (var s in e) if (e.hasOwnProperty(s) && s !== 'zeilen') k[s] = e[s];
    return k;
  }

  function serialisiere(z) {
    return JSON.stringify({
      idx: z.idx, frei: z.frei, quer: z.quer, freiB: z.freiB, freiH: z.freiH,
      rand: z.rand, aktivId: z.aktivId, naechsteId: z.naechsteId, schritt: z.schritt,
      elemente: z.elemente.map(ohneZeilen)
    });
  }

  function uebernehmen(z, json) {
    var d;
    try { d = JSON.parse(json); } catch (e) { return false; }
    if (!d || !d.elemente) return false;
    z.idx = d.idx; z.frei = d.frei; z.quer = d.quer;
    z.freiB = d.freiB; z.freiH = d.freiH; z.rand = d.rand;
    z.aktivId = d.aktivId; z.naechsteId = d.naechsteId || 1;
    z.schritt = d.schritt || 1;
    z.elemente = d.elemente;
    z.elemente.forEach(function (e) { if (e.typ === 'text') zeilenBerechnen(e); });
    return true;
  }

  return {
    K: K, VORLAGEN: VORLAGEN,
    kommazahl: kommazahl, schriftString: schriftString, abstaendeNullen: abstaendeNullen,
    neuerZustand: neuerZustand, masse: masse, nutz: nutz, passt: passt, variante: variante,
    raender: raender, sperre: sperre, formPfad: formPfad, werkstueckPfad: werkstueckPfad,
    bildMasse: bildMasse, dpiVon: dpiVon, qualitaet: qualitaet,
    zeilenBerechnen: zeilenBerechnen, textHoehe: textHoehe, rahmen: rahmen,
    zeichneSzene: zeichneSzene, greifen: greifen, griffe: griffe, mitte: mitte, lokal: lokal,
    ohneZeilen: ohneZeilen, serialisiere: serialisiere, uebernehmen: uebernehmen
  };
})();
